module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "gray-back",
    staticStyle: {
      "padding": ".2rem 0 1rem 0",
      "height": "100%"
    }
  }, [_vm._l((_vm.pageData.subject), function(subject, index) {
    return _c('div', [_c('van-divider', [_vm._v("项目" + _vm._s(index + 1))]), _vm._v(" "), _c('van-cell-group', [_c('van-cell', {
      attrs: {
        "title": "项目",
        "label": subject.subject_name
      }
    }), _vm._v(" "), _c('van-cell', {
      attrs: {
        "title": "参赛队员"
      }
    }), _vm._v(" "), _c('div', {
      directives: [{
        name: "show",
        rawName: "v-show",
        value: (subject.yundongyuan.length > 0),
        expression: "subject.yundongyuan.length>0"
      }],
      staticClass: "memberResultWrap"
    }, _vm._l((subject.yundongyuan), function(yundongyuan, index) {
      return _c('div', {
        staticClass: "memberLi"
      }, [_vm._v("\n                    运动员" + _vm._s(index + 1) + "\n                    "), _c('van-tag', {
        key: index,
        attrs: {
          "round": "",
          "color": "#fff",
          "text-color": "#666",
          "size": "large",
          "type": "primary"
        },
        on: {
          "close": function($event) {
            return subject.yundongyuan.splice(index, 1)
          }
        }
      }, [_vm._v(" " + _vm._s(yundongyuan.name) + " " + _vm._s(yundongyuan.num) + "\n                    ")])], 1)
    }), 0), _vm._v(" "), _c('van-cell', {
      attrs: {
        "title": "教练员"
      }
    }), _vm._v(" "), _c('div', {
      directives: [{
        name: "show",
        rawName: "v-show",
        value: (subject.jiaolian.length > 0),
        expression: "subject.jiaolian.length>0"
      }],
      staticClass: "memberResultWrap"
    }, _vm._l((subject.jiaolian), function(jiaolian, index) {
      return _c('div', {
        staticClass: "memberLi"
      }, [_vm._v("\n                    教练员" + _vm._s(index + 1) + "\n                    "), _c('van-tag', {
        key: index,
        attrs: {
          "round": "",
          "color": "#fff",
          "text-color": "#666",
          "size": "large",
          "type": "primary"
        }
      }, [_vm._v(" " + _vm._s(jiaolian.name) + " " + _vm._s(jiaolian.num) + "\n                    ")])], 1)
    }), 0), _vm._v(" "), _c('van-cell', {
      attrs: {
        "title": "替补队员"
      }
    }), _vm._v(" "), _c('div', {
      directives: [{
        name: "show",
        rawName: "v-show",
        value: (subject.tbydy.length > 0),
        expression: "subject.tbydy.length>0"
      }],
      staticClass: "memberResultWrap"
    }, _vm._l((subject.tbydy), function(tbydy, index) {
      return _c('div', {
        staticClass: "memberLi"
      }, [_vm._v("\n                    替补运动员" + _vm._s(index + 1) + "\n                    "), _c('van-tag', {
        key: index,
        attrs: {
          "round": "",
          "color": "#fff",
          "text-color": "#666",
          "size": "large",
          "type": "primary"
        }
      }, [_vm._v(" " + _vm._s(tbydy.name) + " " + _vm._s(tbydy.num) + "\n                    ")])], 1)
    }), 0), _vm._v(" "), (subject.sf_music_status == false && subject.music_url) ? _c('van-cell', {
      attrs: {
        "title": "自选音乐",
        "is-link": ""
      }
    }, [_c('a', {
      attrs: {
        "href": subject.music_url
      }
    }, [_vm._v("已上传")])]) : _vm._e(), _vm._v(" "), (subject.sf_music_status == false && subject.music_url == '' && subject.music_status == 1) ? _c('van-cell', {
      attrs: {
        "title": "自选音乐",
        "is-link": ""
      },
      on: {
        "click": function($event) {
          _vm.showMusicDialog = true;
          _vm.musicSubjectId = subject.id
        }
      }
    }, [_c('em', {
      staticStyle: {
        "color": "#ff0000"
      }
    }, [_vm._v("现在上传/现场提交")])]) : _vm._e(), _vm._v(" "), (subject.sf_music_status == false && subject.music_url && subject.music_status == 1) ? _c('van-cell', {
      attrs: {
        "title": "音乐试听",
        "is-link": ""
      },
      on: {
        "click": function($event) {
          return _vm.listen(subject)
        }
      }
    }, [_c('em', {
      staticStyle: {
        "color": "#ff0000"
      }
    }, [_vm._v("未试听,请点击确认试听")])]) : _vm._e(), _vm._v(" "), (subject.sf_music_status == false && subject.music_url && subject.music_status == 2) ? _c('van-cell', {
      attrs: {
        "title": "音乐试听"
      }
    }, [_vm._v("\n                 已试听\n            ")]) : _vm._e(), _vm._v(" "), (subject.sf_music_status == false && subject.music_status == 3) ? _c('van-cell', {
      attrs: {
        "title": "音乐试听"
      }
    }, [_vm._v("\n                 现场提交并核对\n            ")]) : _vm._e(), _vm._v(" "), _c('van-cell', {
      attrs: {
        "title": "现场照片服务",
        "value": subject.photo_service == 1 ? '是' : '否'
      }
    })], 1)], 1)
  }), _vm._v(" "), _c('div', {
    staticStyle: {
      "padding": "20px"
    }
  }, [(_vm.pageData.confirm_2 == 2) ? _c('van-button', {
    attrs: {
      "type": "primary",
      "size": "large"
    },
    on: {
      "click": function($event) {
        $event.stopPropagation();
        return _vm.save($event)
      }
    }
  }, [_vm._v("信息无误 我已确认")]) : _c('van-button', {
    attrs: {
      "type": "primary",
      "size": "large",
      "plain": ""
    }
  }, [_vm._v("信息已确认")]), _vm._v(" "), _c('van-button', {
    staticStyle: {
      "margin": "10px 0"
    },
    attrs: {
      "size": "large",
      "plain": ""
    },
    on: {
      "click": function($event) {
        $event.stopPropagation();
        return _vm.edit($event)
      }
    }
  }, [_vm._v("信息需要修改")]), _vm._v(" "), _c('van-button', {
    staticStyle: {
      "margin": "10px 0"
    },
    attrs: {
      "size": "large",
      "plain": ""
    },
    on: {
      "click": function($event) {
        $event.stopPropagation();
        return _vm.goIndex($event)
      }
    }
  }, [_vm._v("返回首页")])], 1), _vm._v(" "), _c('van-dialog', {
    attrs: {
      "title": "自选音乐",
      "visible": _vm.showMusicDialog
    },
    on: {
      "update:visible": function($event) {
        _vm.showMusicDialog = $event
      }
    }
  }, [_c('el-upload', {
    staticClass: "upload-demo",
    staticStyle: {
      "width": "100%"
    },
    attrs: {
      "action": "",
      "accept": "audio/mp3",
      "show-file-list": false,
      "before-upload": _vm.onReadMusic
    }
  }, [_c('van-button', {
    attrs: {
      "type": "primary",
      "size": "large",
      "plain": ""
    }
  }, [_vm._v("现在上传")])], 1), _vm._v(" "), _c('van-button', {
    staticStyle: {
      "margin": "10px 0"
    },
    attrs: {
      "size": "large",
      "plain": ""
    },
    on: {
      "click": function($event) {
        return _vm.musicNoSubmit()
      }
    }
  }, [_vm._v("现场提交")])], 1), _vm._v(" "), (_vm.loadding) ? _c('div', {
    staticClass: "mask"
  }, [_c('van-loading', {
    attrs: {
      "type": "spinner",
      "color": "white"
    }
  })], 1) : _vm._e()], 2)
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-146d6eca","hasScoped":true,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/page/apps/sai/saiConfirmDetail2.vue
// module id = 1150
// module chunks = 0